module.exports = __webpack_public_path__ + "img/pro_nine_5.990f69cc.jpg";